'use client';

import { m } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { SimpleLayout } from 'src/layouts/simple';
import { ForbiddenIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';
import { SignOutButton } from 'src/layouts/components/sign-out-button';
import { Stack } from '@mui/material';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export function View403() {
  const { t } = useTranslation('common');
  const router = useRouter();
  return (
    <SimpleLayout content={{ compact: true }}>
      <Container component={MotionContainer}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }} suppressHydrationWarning>
            {t('errors.noPermission')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }} suppressHydrationWarning>
            {t('errors.restrictedAccessMessage')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ my: { xs: 5, sm: 10 } }} />
        </m.div>

        <Stack direction="row" spacing={2} >
          <Button component={RouterLink} sx={{ flex: 1}} href="/dashboard/activities" size="large" variant="contained" suppressHydrationWarning>
            {t('errors.goToHome')}
          </Button>
          <SignOutButton
            sx={{ flex: 1}}
            size="medium"
            variant="text"
            onClose={() => {
              router.push(paths.auth.jwt.signIn);
            }}
          />
        </Stack>
      </Container>
    </SimpleLayout>
  );
}
